export default {
	"transSec.SorryFailedToCreateOrder": "抱歉，创建订单失败！",
	"transSec.CopiedSuccessfully": "已成功复制!",
	"transSec.ReplicationIsNotSupported": "不支持复制",
	"transSec.ParameterError": "参数错误!",
	"transSec.CongratulationsOnYourSuccessfulUpgrade": "恭喜您已升级成功",
	"transSec.CallItOfficial": "叫叫官方",
	"transSec.UpgradeContent": "升级内容：",
	"transSec.UpgradeType": "升级类型：",
	"transSec.SubscriptionsArePaidAnnually": "订阅转年付",
	"transSec.TheAmountOfTheItem": "商品金额",
	"transSec.SubscriptionPaidIn": "订阅实付",
	"transSec.UpgradeOffers": "升级优惠",
	"transSec.expenses": "费用",
	"transSec.AfterTheUpgradeIsSuccessfulYouCanViewYourUpgradeInformationInTheFirstOrderOfTheSubscriptionAtTheSameTimeTheAutomaticDeductionOfTheOriginalSubscriptionWillBeAutomaticallyTerminatedThroughTheSystemAndWillNotBeRepeatedlyCharged": "升级成功后，您可在订阅的首个订单中查看您的升级信息；同时原订阅自动扣款将通过系统自动解约，不会重复扣款",
	"transSec.OrderNumber": "订单编号",
	"transSec.copy": "复制",
	"transSec.TheTimeOfPlacingTheOrder": "下单时间",
	"transSec.PaymentMethods": "支付方式",
	"transSec.PaymentTime": "支付时间",
	"transSec.ActualPayment": "实付款：",
	"transSec.DetermineTheUpgrade": "确定升级",
	"transSec.prompt": "提示",
	"transSec.GotIt": "知道了",
	"transSec.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付该订单请在【叫叫】公众号的订单物流中进行支付",
	"transSec.TheUpgradeRateChangesDueToChangesInTheNumberOfSubscriptionPeriods": "因您的订阅期数发生变化导致升级幅度变动",
	"transSec.ItemAmount": "商品金额：",
	"transSec.SubscriptionPayment": "订阅实付：",
	"transSec.UpgradeOffer": "升级优惠：",
	"transSec.Expenses": "费用：",
	"transSec.return": "返回",
	"transSec.GoOn": "继续"
}